









































































import '../styles/menu-tile.css'
import { CIcon } from '@coreui/icons-vue'
import {
  cilExternalLink,
  cilChevronBottomAlt,
  cilChevronTopAlt,
} from '@coreui/icons-pro'

import Vue, { PropOptions } from 'vue'

interface ILink {
  url: string
  name: string
  image?: string
}

export default Vue.extend({
  data() {
    return {
      menuOpen: false,
      linkIcon: cilExternalLink,
      openMenuIcon: cilChevronBottomAlt,
      closeMenuIcon: cilChevronTopAlt,
    }
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: Array,
      required: false,
    },
    iconImage: {
      type: String,
      required: false,
    },
    route: {
      type: String,
      required: false,
    },
    url: {
      type: String,
      required: false,
    },
    links: {
      type: Array,
      required: false,
    } as PropOptions<ILink[]>,
  },
  name: 'MenuTile',
  components: { CIcon },
  methods: {},
})
